import IMInventoryEntry from './IMInventoryEntry';

export default IMInventoryEntry;
